var scope_0 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1dc9ae4a8b101994025aad4b17ad5384.js').default;

var scope_1 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/368d1c8467950149d7097dd0318b2df8.js').default;

var scope_2 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4cd668d8262e973681db4a13a69e5c97.js').default;

var scope_3 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/560e0e10dca791ca27f57e2ca7bf0b3a.js').default;

var scope_4 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5773867a9d22729f0af08329f92d84bf.js').default;

var scope_5 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6f81724b711ba26fe29251846b4dadb3.js').default;

var scope_6 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/993a5c63c27594cbe28f6dae85cf6675.js').default;

var scope_7 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a32b39bafa80b749b77e81aa1133eee9.js').default;

var scope_8 = require('/opt/build/repo/doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8);